import React from 'react';
import { Breadcrumbs, Link, ModuleBase, ResponsiveImage, SocialImage } from '@/components';
import { useTranslations } from 'next-intl';
import { ExpertElementModel } from './ExpertElement';

const ExpertElementPublic = (data: ExpertElementModel) => {
  const { breadcrumb, name, jobTitle, shortBio, socialMedia, image } = data.props;

  const t = useTranslations();

  return (
    <ModuleBase data={data} noPadding className="relative overflow-hidden">
      <div className="top-0 right-0 h-full w-full overflow-hidden md:absolute md:w-1/2 lg:w-5/12 xl:w-4/12">
        {image && (
          <ResponsiveImage
            image={image}
            widths={{ xs: 600, sm: 456, md: 512, lg: 611, xl: 611, xxl: 700 }}
            heights={{ xs: 600, sm: 684, md: 769, lg: 918, xl: 918, xxl: 1000 }}
          />
        )}
      </div>

      <div className="container pt-4 pb-[90px] md:pt-20 xl:min-h-[905px] xl:pb-[200px]">
        <div className="flec-col flex w-full flex-col gap-5 md:w-6/12 md:pr-4 lg:w-7/12 lg:gap-5 lg:pr-10 xl:w-8/12">
          {breadcrumb && <Breadcrumbs data={breadcrumb} />}
          {name && <h1 className="text-style-h3">{name}</h1>}
          {jobTitle && <p className="text-style-h5">{jobTitle}</p>}
          {shortBio && <div className="text-style-body mt-8" dangerouslySetInnerHTML={{ __html: shortBio }} />}
          {socialMedia && (
            <div className="mt-10 flex gap-5">
              {socialMedia.map((media, index) => (
                <Link key={index} link={media.link} className="btn v2 secondary flex items-center">
                  <SocialImage type={media.socialPlatform} className="filter-black !mr-0 h-5 w-5" />
                  <span className="">{t('general.$viewprofile')}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </ModuleBase>
  );
};

export default ExpertElementPublic;
